module.exports = __webpack_public_path__ + "static/media/8base-appbuilder-news.ca9092e7.png";